export default "__VITE_ASSET__YQm8W2O8__"